export default {
    getParentJsonKeyName: sdt => {
        if (sdt === 'a') return 'sociodemo_sociodemo_age'
        if (sdt === 'g') return 'sociodemo_sociodemo_gender'
        if (sdt === 'e') return 'sociodemo_sociodemo_education'
        if (sdt === 'i') return 'sociodemo_sociodemo_income'
    },

    getJsonKeySubType: sdt => {
        if (sdt === 'a') return 'age'
        if (sdt === 'g') return 'gender'
        if (sdt === 'e') return 'education'
        if (sdt === 'i') return 'income'
    }
}
